<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '--实时' : '新建' + '-曲线图-实时'" :has-form="true" class="time-event-dialog-modal" @close="close"
      @confirm="handleConfirm" width="30%">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <gs-input v-model="description" />
            </gs-form-item>
            <div class="fifty-width-box">
              <fieldset>
                <legend>主Y轴</legend>
                <gs-form-item label="最小值" prop="target" class="form-item-radio">
                  <gs-input v-model="form.primaryY_Mininum" />
                </gs-form-item>
                <gs-form-item label="最大值" prop="target" class="form-item-radio">
                  <gs-input v-model="form.primaryY_maximum" />
                </gs-form-item>
              </fieldset>
            </div>
            <div class="fifty-width-box">
              <fieldset>
                <legend>副Y轴</legend>
                <gs-form-item label="最小值" prop="target" class="form-item-radio">
                  <gs-input v-model="form.secondaryY_Mininum" />
                </gs-form-item>
                <gs-form-item label="最大值" prop="target" class="form-item-radio">
                  <gs-input v-model="form.secondaryY_maximum" />
                </gs-form-item>
              </fieldset>
            </div>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="数据" name="second">
          <div>
            <span style="color: #ff8706;cursor: pointer" @click="add">添加数据</span>
            <div class="form-item-objectSeries">
              <el-table :data="form.objectSeries" size="mini"
                :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
                style="width: 100%">
                <el-table-column prop="name" label="名称" align="center">
                </el-table-column>
                <!--  <el-table-column prop="type" label="类型" align="center">
                </el-table-column> -->
                <el-table-column prop="name" label="坐标轴" align="center" width="150">
                  <template slot-scope="scope">
                    <gs-select v-model="scope.row.YAxis" style="width: 100px;" size="mini">
                      <gs-option size="mini" v-for="item in calculations" :key="item.value" :label="item.label"
                        :value="item.value">
                      </gs-option>
                    </gs-select>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete" @click="del(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
        :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
    </gs-modal>
    <!--去掉了:before-close="beforeClosePropertxies"-->
    <gs-modal v-model="visibleProperties" class="my-test-class" title="属性" @close="closeProperties"
      @confirm="handleConfirmProperties">
      <gs-select />
    </gs-modal>
    <gs-modal title="帮助-曲线图" v-model="dialogHelp" class="my-test-class" width="42%" :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">实时曲线图对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">对该对象的描述</span><br>
      <span class="tit">主Y轴</span><span class="txt"></span><br>
      <span class="tit">最小值：</span><span class="txt">默认值0</span><br>
      <span class="tit">最大值：</span><span class="txt">默认值100</span><br>
      <span class="tit">副Y轴</span><span class="txt"></span><br>
      <span class="tit">最小值：</span><span class="txt">默认值0</span><br>
      <span class="tit">最大值：</span><span class="txt">默认值100</span><br>
      <span class="tab">动态图</span><br>
      <hr />
      <span class="tit">对象列表：</span><span class="txt">选择要实时查看的点位,并选择Y轴的属性(有主轴与副轴两种选择)</span><br>
      <span class="tit">添加：</span><span class="txt">选择添加多个点位</span><br>
      <span class="tit">删除：</span><span class="txt">选择删除多个点位</span><br>
      <span class="tab">时间段</span><br>
      <hr />
      <span class="tit">时间段设置</span><span class="txt"></span><br>
      <span class="tit">时间段：</span><span class="txt">选择查看一段时间的数据,可以选择1小时或者半小时.当超过该1小时或者半小时后,之前的数据无法查看.</span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";
import eventBus from "../timeChart/vue.js";
export default {
  components: {},
  data() {
    return {
      dialogHelp: false,
      calculation: 0,
      calculations: [
        {
          value: 0,
          label: "主轴",
        },
        {
          value: 1,
          label: "副轴",
        },
        {
          value: 2,
          label: "方波",
        },
      ],
      waves: 0,
      waveArray: [
        {
          value: 0,
          label: "是",
        },
        {
          value: 1,
          label: "否",
        },
      ],
      objectInfo: {},
      loading: false,
      activeName: "first",
      form: {
        objectSeries: [],
        primaryY_autoScale: false,
        primaryY_Mininum: 0,
        primaryY_maximum: 1000,
        secondaryY_autoScale: false,
        secondaryY_Mininum: 0,
        secondaryY_maximum: 1000,
        logInterval_value: 1,
        logInterval_unit: "m",
        maxLogNum: "",
      },
      description: "",
      checked: "",
      options: [
        {
          label: "1小时",
          value: "s",
        },
        {
          label: "半小时",
          value: "m",
        },
      ],
      visibleAdd: false,
      visibleProperties: false,
      addList: [],
      props: {
        label: "name",
        disabled: "type:folder",
      },
      selectList: [],
      name: "",
      showList: [],
      row: "",
      isEdit: false,
      oldData: {},
    };
  },
  computed: {
    ...mapState({
      visible: "onlineChartDialogShow",
      nodeData: "objectInfo",
    }),
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData;
    },
    nodeData() { },
    visible() {
      if (this.visible) {
        this.objectInfo = JSON.parse(JSON.stringify(this.nodeData));
        setTimeout(() => {
          this.$refs.nameInput.focus();
        }, 100);
        if (JSON.stringify(this.objectInfo) !== "{}" && this.objectInfo.type === "onlineChart") {
          this.isEdit = true;
          this.activeName = "first";
          this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {};
          this.description = this.objectInfo.description ? this.objectInfo.description : "";
          this.name = this.objectInfo.name ? this.objectInfo.name : "";
          this.form.objectSeries = this.objectInfo.attribute.objectSeries ? JSON.parse(JSON.stringify(this.objectInfo.attribute.objectSeries)) : [];
        } else {
          this.isEdit = false;
          this.activeName = "first";
          this.form = {
            objectSeries: [],
            primaryY_autoScale: false,
            primaryY_Mininum: 0,
            primaryY_maximum: 1000,
            secondaryY_autoScale: false,
            secondaryY_Mininum: 0,
            secondaryY_maximum: 1000,
            logInterval_value: 1,
            logInterval_unit: "s",
            maxLogNum: "",
          };
          this.description = "";
          this.name = "";
        }
      }
    },
  },
  created() { },
  mounted() { },
  methods: {
    ...mapMutations({
      close: "ONLINECHART_PROPERTIES_DIALOG_HIDE",
      needReload: "NEED_RELOAD_TREE",
    }),
    beforeClose() {
      console.log("关闭创建窗口");
      console.log(this.nodeData);
      this.close();
    },
    // cancel () {
    //   this.nodeData = this.oldData
    //   this.close()
    // },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning("Y轴最小值必须小于最大值");
          return;
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning("Y轴最小值必须小于最大值");
          return;
        }
      }
      // done(false)可以阻止modal关闭
      done();
    },
    handleConfirm() {
      let _this = this;
      this.loading = true;
      let arr = [];
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries));
      this.form.objectSeries.forEach((e) => {
        let obj = {
          id: e.id,
          YAxis: e.YAxis,
          name: e.name,
          type: e.type,
          wave: 0,
        };
        arr.push(obj);
      });
      this.form.objectSeries = arr;
      if (this.objectInfo.id && this.objectInfo.type === "onlineChart") {
        let param = {
          id: this.objectInfo.id,
          name: this.name,
          type: this.objectInfo.type,
          value: this.objectInfo.value,
          parentId: this.objectInfo.parentId,
          description: this.description,
          attribute: this.form, // 其他信息这里，键值对形式
        };
        service.renamePoint(param).then((res) => {
          this.loading = false;
          this.$Message.success("修改成功");
          _this.objectInfo.attribute.objectSeries = backArr;
          this.close();
          this.objectInfo.name = this.name;
          res.attribute.objectSeries = backArr;
          this.$store.state.tabPanel = res;
          this.$store.state.updateTreeNode = res;
          this.description = "";
          this.name = "";
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = [];
          // eventBus.$emit('changeInterval', res)
        })
          .catch((err) => {
            this.loading = false;
            this.form.objectSeries = backArr;
            this.$Message.error(err.message);
          });
      } else {
        let param = {
          name: this.name,
          type: "onlineChart",
          parentId: this.objectInfo.id,
          description: this.description,
          attribute: this.form, // 其他信息这里，键值对形式
        };
        service.newAddPoint(param).then((res) => {
          this.loading = false;
          this.$Message.success("添加成功");
          setTimeout(() => {
            res.attribute.objectSeries = backArr;
            _this.$store.state.addTreeNode = res;
          }, 0);
          this.close();
          this.description = "";
          this.name = "";
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = [];
        })
          .catch((err) => {
            this.loading = false;
            this.form.objectSeries = backArr;
            this.$Message.error(err.message);
          });
      }
    },
    onChange(v) { },
    add() {
      let _this = this;
      this.visibleAdd = true;
      let id = ""
      if (_this.isEdit) {
        id = this.nodeData.parentId
      } else {
        id = this.nodeData.id
      }
      service.getTree("Point", id).then((res) => {
        this.addList = res;
        if (
          _this.form.objectSeries !== null &&
          _this.form.objectSeries.length > 0
        ) {
          setTimeout(() => {
            _this.form.objectSeries.forEach((res) => {
              _this.$refs.tree.setChecked(res.id, true);
            });
          }, 0);
        }
      });
    },
    del(val) {
      this.form.objectSeries.forEach((value, index, array) => {
        if (val.name === value.name) {
          this.form.objectSeries.splice(index, 1);
        }
      });
      /* if (this.selectList === null || this.selectList.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selectList.forEach((value, index, array) => {
        this.form.objectSeries = this.form.objectSeries.filter(e => {
          return e.id !== value.id
        })
      })*/
    },
    yAxis() { },
    property() {
      if (this.selectList.length !== 1) {
        this.$Message.warning("只能勾选一项");
        return;
      }
      this.visibleProperties = true;
    },
    beforeCloseAdd() {
      this.visibleAdd = false;
    },
    closeAdd() {
      this.visibleAdd = false;
    },
    handleConfirmAdd() {
      let _this = this;
      this.$refs.tree.getCheckedNodes(true).forEach((e) => {
        e.data["YAxis"] = 0
        _this.form.objectSeries.push(e.data);
      });
      this.form.objectSeries = this.unique(this.form.objectSeries, "id");
      this.visibleAdd = false;
    },
    unique(arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    beforeCloseProperties() {
      this.visibleProperties = false;
    },
    closeProperties() {
      this.visibleProperties = false;
    },
    handleConfirmProperties() {
      this.visibleProperties = false;
    },
    checkEvent(node, isSelect, halfSelect) {
      // value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      switch (node.type) {
        /* case "value_Analog":
          break;
        case "value_Multistate":
          break;
        case "value_Binary":
          break;
        case "value_String":
          break;
        case "BinaryInput":
          break;
        case "BinaryOutput":
          break;
        case "AnalogInput":
          break;
        case "AnalogOutput":
          break;

        default:
          this.$Message.error("此节点为目录，无法被选择");
          this.$refs.tree.setChecked(node.id, false);
          break; */
      }
    },
    selectData(selection, row) {
      this.selectList = selection;
    },
    handleCloseHelp() {
      this.dialogHelp = false;
    },
  },
};
</script>
<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 200px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.tab {
  font-size: 16px;
  font-weight: 800;
}

.tit {
  font-size: 14px;
  font-weight: 800;
  color: #ffffff;
}

.txt {
  font-size: 14px;
  color: #ffffff;
}
</style>
<style>
.gs-select-menu-item.is-selected {
  background-color: transparent !important;
}

.gs-button-default {
  background-color: transparent !important;
  color: #bdbdbd;
}

.gs-button.is-disabled.gs-button-default,
.gs-button.is-disabled.gs-button-primary {
  background-color: rgba(136, 136, 136, 0.42);
  color: #8a8a8a;
}

.gs-select-menu-item-label {
  color: #f9f9f9 !important;
}

.gs-select-wrap.is-disabled,
.gs-select-wrap.is-disabled .gs-select-input-value {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/left-side/onlineChartPropertity.vue